import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { RemoveService, RequestDeletionRequest } from '../services/remove.service';

@Component({
  selector: 'app-remove',
  standalone: true,
  imports: [CommonModule, FormsModule, HeaderComponent, FooterComponent],
  templateUrl: './remove.component.html',
  styleUrl: './remove.component.scss'
})
export class RemoveComponent implements OnInit {
  email: string = '';
  isSubmitting: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  showSuccess: boolean = false;
  showError: boolean = false;

  constructor(
    private router: Router,
    private removeService: RemoveService,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Définir le titre de la page (45 caractères - optimal)
    this.title.setTitle('Supprimer mes données – pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Demandez la suppression de vos données personnelles sur pdf-to-word.fr. Conformité RGPD : droit à l\'effacement de vos informations en toute sécurité.' });
    this.meta.updateTag({ name: 'keywords', content: 'supprimer données pdf-to-word, RGPD conversion PDF, effacement données personnelles, droit à l\'oubli, protection vie privée' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Supprimer mes données – pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Demandez la suppression de vos données personnelles sur pdf-to-word.fr. Conformité RGPD : droit à l\'effacement de vos informations en toute sécurité.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  onSubmit() {
    if (this.email && this.isValidEmail(this.email)) {
      this.isSubmitting = true;
      this.clearMessages();
      
      const requestData: RequestDeletionRequest = {
        email: this.email,
        idSite: 6 // Identifiant du site
      };

      this.removeService.requestDeletion(requestData).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          this.successMessage = response.message || 'Votre demande de suppression a été envoyée. Vous recevrez un email de confirmation sous peu.';
          this.showSuccess = true;
          this.email = '';
        },
        error: (error) => {
          this.isSubmitting = false;
          this.errorMessage = error.message || 'Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer.';
          this.showError = true;
        }
      });
    }
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private clearMessages() {
    this.showSuccess = false;
    this.showError = false;
    this.successMessage = '';
    this.errorMessage = '';
  }

  dismissSuccess() {
    this.showSuccess = false;
    this.successMessage = '';
  }

  dismissError() {
    this.showError = false;
    this.errorMessage = '';
  }
}
